module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"type":"Trip Type","selectType":"Select trip type"},"no":{"type":"Type Tur","selectType":"Velg turtype"}}')
  delete Component.options._Ctor
}
